"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.umacareDiagnosticsArray = void 0;
exports.umacareDiagnosticsArray = [
    "INESP   Sospecha COVID19",
    "INESP   Contacto estrecho COVID19",
    "INESP   confirmado COVID19 x hisopado",
    "INESP   confirmado COVID19 x epidemiol"
];
